module.exports = "https://www.gc-pro.gnp.com.mx/a9c40b03d8047ad9381b8fe6c70f0d66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/datos-siniestro.svg
// module id = 1814
// module chunks = 0